import axios from 'axios'
import router from '../router'
import store from '@/store'

const baseUrl = process.env.BASE_URL

export async function send(url, {
  method = 'GET',
  data = {},
  headers = {}
}) {
  let responseData
  try {
    const response = await axios({
      url: `${baseUrl}${url}`,
      timeout: 1000 * 120,
      method: method,
      headers: {
        'moma-client-type': 'moma-client/web',
        ...headers
      },
      data
    })
    responseData = response.data
    if (responseData.code === 4001) {
      localStorage.removeItem('token')
      router.push('/login')
    } else if (responseData.code === 4007) { // 4007 '无权限访问'的返回码无需做'错误信息提示'
      // alert(responseData.msg + ' [' + url + ']')
      // store.state.reqLog.push(responseData)
      console.error(responseData.msg + ' [' + url + ']')
      // debugger
    } else if (!responseData.success) {
      store.state.reqLog.push(responseData)
    }
  } catch (e) {
    responseData = (e.response && e.response.data) || {
      success: false,
      type: 'RT',
      msg: 'Request Timeout'
    }
    store.state.reqLog.push(responseData)
  }

  return responseData
}

export async function postReq(url, {data, headerMap = {}, headerCodeMap = {}}) {
  let headers = {
    'Content-Type': 'application/json',
    'x-moma-token': localStorage.getItem('token'),
    'lang': store.state.language,
    ...headerMap,
    ...headerCodeMap
  }

  return send(url, {
    method: 'POST',
    data,
    headers
  })
}

export async function getReq(url, {headerMap = {}, headerCodeMap = {}} = {headerMap: {}, headerCodeMap: {}}) {
  let headers = {
    'x-moma-token': localStorage.getItem('token'),
    'lang': store.state.language,
    ...headerMap,
    ...headerCodeMap
  }

  return send(url, {
    headers
  })
}

export async function deleteSendReq(url, {headerMap = {}, headerCodeMap = {}} = {headerMap: {}, headerCodeMap: {}}) {
  return send(url, {
    method: 'DELETE',
    headers: {
      'x-moma-token': localStorage.getItem('token'),
      'lang': store.state.language,
      ...headerMap,
      ...headerCodeMap
    }
  })
}

export async function putReq(url, {data, headerMap = {}, headerCodeMap = {}}) {
  return send(url, {
    method: 'PUT',
    data,
    headers: {
      'Content-Type': 'application/json',
      'x-moma-token': localStorage.getItem('token'),
      'lang': store.state.language,
      ...headerMap,
      ...headerCodeMap
    }
  })
}

export async function exportExcelReq(url, {data, headerMap = {}, headerCodeMap = {}}) {
  let headers = {
    // 'Content-Type': 'application/vnd.ms-excel',
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/octet-stream',
    'x-moma-token': localStorage.getItem('token'),
    'lang': store.state.language,
    ...headerMap,
    ...headerCodeMap
  }
  return axios.post(`${baseUrl}${url}`, data, {
    headers: headers,
    responseType: 'arraybuffer'
  }).then(res => res.data.data || res.data)
}

export async function exportExcelGetReq(url, {headerMap = {}, headerCodeMap = {}} = {headerMap: {}, headerCodeMap: {}}) {
  let headers = {
    // 'Content-Type': 'application/vnd.ms-excel',
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/octet-stream',
    'x-moma-token': localStorage.getItem('token'),
    'lang': store.state.language,
    ...headerMap,
    ...headerCodeMap
  }
  return axios.get(`${baseUrl}${url}`, {
    headers,
    responseType: 'arraybuffer'
  }).then(res => res.data.data || res.data)
}

export async function getCPHeaderMap(compId, projId) {
  // debugger
  return {
  }
}

export async function getHeaderCodeMap(codeParam) {
  // debugger
  return codeParam ? {
    'moma-module-code': codeParam.moduleCode || ''
  } : {}
}



// WEBPACK FOOTER //
// ./src/api/methods.js